import { getStorage } from '@/shared/lib'

import type { KeywordSearchHistory } from './history'

export const STORAGE_KEY = 'keyword-search-history'

export const DEFAULT_KEYWORD_SEARCH_HISTORY: KeywordSearchHistory[] = []

export const getKeywordSearchHistory = () => {
  const history = getStorage(STORAGE_KEY)

  if (!history) {
    return DEFAULT_KEYWORD_SEARCH_HISTORY
  }

  return JSON.parse(history) as KeywordSearchHistory[]
}
